export default "__VITE_ASSET__qeuvvlpI__"